module.exports = __webpack_public_path__ + "static/FAQ-team3-2a5ec38d292ca9594f3c72e4bda20a4a.jpg";